import { Injectable } from '@angular/core';
import { LabTestResult } from '../lab-test-results';

@Injectable()
export class LabResultsSortInfo {
    public readonly subjectLevel: SubjectLevelSortInfo;

    constructor() {
        const testGroupLevel: keyof LabTestResult = 'testGroup';
        const testLevel: keyof LabTestResult = 'testSequence';

        this.subjectLevel = {
            allLevels: [testGroupLevel, testLevel],
            testGroupLevel: labTestResult => labTestResult[testGroupLevel],
            testLevel: labTestResult => labTestResult[testLevel]
        };
    }
}

interface SubjectLevelSortInfo {
    allLevels: (keyof LabTestResult)[];
    testGroupLevel: (labTestResult: LabTestResult) => string;
    testLevel: (labTestResult: LabTestResult) => number;
}

export type LabTestSortArgs = (keyof LabTestResult | ((lab: LabTestResult ) => number | null))[];